export const seoSections = [
  {
    heading: null,
    paragraphs: [
      "Lavenza Masaj Salonu, Bursa'nın Nilüfer ilçesinde, Konak Mahallesi'nde hizmet veren bir masaj salonudur. Günlük hayatın temposunda biriken yorgunluğu geride bırakmak isteyen misafirlerimize sakin, temiz ve özenle hazırlanmış bir ortamda profesyonel masaj hizmeti sunuyoruz. Amacımız, kapıdan içeri adım attığınız andan ayrıldığınız ana kadar kendinizi rahat ve değerli hissetmenizdir.",
    ],
  },
  {
    heading: "Nilüfer ve Konak Mahallesi'nde Kolay Ulaşılabilir Konum",
    paragraphs: [
      "Salonumuz Konak Mahallesi, Kurşunlu Sokak üzerinde, Kat 1 Daire 2'de yer alır. Nilüfer'in merkezi noktalarından ve Bursa'nın farklı semtlerinden ulaşım oldukça pratiktir; toplu taşıma ya da özel araçla kısa sürede bize ulaşabilirsiniz. Konak masaj salonu arayışında olan misafirlerimiz için konumumuz, iş çıkışı veya hafta sonu planlarına kolayca uyum sağlar. Yol tarifi için sayfamızdaki harita bağlantısını kullanabilir ya da WhatsApp üzerinden bize yazabilirsiniz.",
    ],
  },
  {
    heading: "Profesyonel Hizmet Anlayışı",
    paragraphs: [
      "Lavenza'da her uygulama, misafirimizin ihtiyacı dinlenerek başlar. Seans öncesinde beklentilerinizi, hassas bölgelerinizi ve tercih ettiğiniz baskı seviyesini konuşuruz; böylece uygulama tamamen size göre şekillenir. Kullanılan ürünlerden oda sıcaklığına, müzikten aydınlatmaya kadar tüm detaylar rahatlamanızı destekleyecek şekilde düzenlenir. Bursa'da profesyonel masaj arayan herkes için hijyen ve mahremiyet bizim için pazarlık konusu değildir.",
    ],
  },
  {
    heading: "Klasik Masaj",
    paragraphs: [
      "Klasik masaj, uzun ve akıcı hareketlerle kas gerginliğini azaltmaya ve kan dolaşımını desteklemeye yönelik en bilinen masaj türüdür. Yoğun bir haftanın ardından genel bir rahatlama arayan misafirlerimiz tarafından sıklıkla tercih edilir. Orta şiddette baskı ile uygulanır ve seans sonunda hem bedensel hem zihinsel bir hafiflik hissi bırakmayı hedefler.",
    ],
  },
  {
    heading: "Medikal Masaj",
    paragraphs: [
      "Medikal masaj, belirli kas gruplarındaki gerginlik, sertlik ve hareket kısıtlılığına odaklanan daha hedefli bir uygulamadır. Uzun süre masa başında çalışanlar, ağır fiziksel aktivite yapanlar ya da boyun ve sırt bölgesinde yoğunluk hissedenler için uygun bir seçenek olabilir. Uygulama öncesinde şikâyetleriniz detaylı olarak dinlenir ve seans buna göre planlanır.",
    ],
  },
  {
    heading: "Soft Masaj",
    paragraphs: [
      "Soft masaj, hafif dokunuşlar ve yavaş bir ritimle uygulanan, tamamen gevşemeye odaklı nazik bir masajdır. Yoğun baskıdan kaçınan, masaj deneyimine yeni başlayan ya da sadece sakin bir mola vermek isteyen misafirlerimiz için idealdir. Nilüfer spa deneyimi arayanların en çok tercih ettiği uygulamalardan biridir.",
    ],
  },
  {
    heading: "Kese & Köpük",
    paragraphs: [
      "Geleneksel hamam kültürünün vazgeçilmezi kese ve köpük uygulaması, cildi ölü hücrelerden arındırır ve yumuşacık bir his bırakır. Kese ile yapılan arındırmanın ardından uygulanan bol köpüklü yıkama hem ferahlatır hem de masaj öncesi cildi hazırlar. Klasik veya soft masaj ile birlikte tercih edildiğinde bütünsel bir Bursa spa ritüeline dönüşür.",
    ],
  },
  {
    heading: "WhatsApp ile Kolay Randevu",
    paragraphs: [
      "Randevu almak için telefon trafiğiyle uğraşmanız gerekmez. WhatsApp hattımıza kısa bir mesaj göndererek uygun gün ve saati birlikte belirleyebilir, hizmetler hakkında sorularınızı iletebilirsiniz. Fiyat ve süre bilgisi için WhatsApp'tan yazmanız yeterlidir; size en kısa sürede dönüş yaparız. Dilerseniz doğrudan arayarak da randevunuzu oluşturabilirsiniz.",
    ],
  },
  {
    heading: "Temiz ve Konforlu Bir Ortam",
    paragraphs: [
      "Her seans öncesinde odalarımız havalandırılır, kullanılan tüm tekstil ürünleri değiştirilir ve yüzeyler özenle temizlenir. Loş aydınlatma, sakin müzik ve hoş kokularla desteklenen atmosferimiz, Bursa masaj deneyiminizi gerçek bir mola haline getirir. Nilüfer masaj salonu arayan misafirlerimizi, kendinizi evinizde gibi hissedeceğiniz bu ortamda ağırlamaktan mutluluk duyarız.",
    ],
  },
];

export const homeFaq = [
  {
    q: "Bursa masaj salonu nerede?",
    a: "Lavenza Masaj Salonu, Bursa'nın Nilüfer ilçesinde Konak Mahallesi, Kurşunlu Sokak, Kat:1 Daire:2 adresinde bulunur. Nilüfer merkezine ve Bursa'nın ana ulaşım hatlarına yakın konumdayız. Sayfamızdaki harita üzerinden konumumuzu görebilir, \"Yol tarifi al\" bağlantısıyla navigasyonu başlatabilirsiniz.",
  },
  {
    q: "Nilüfer masaj salonu için nasıl randevu alabilirim?",
    a: "En hızlı yol WhatsApp hattımıza mesaj göndermektir; sayfadaki \"WhatsApp'tan Randevu\" butonu hazır bir mesajla sohbeti açar. Dilerseniz +90 542 164 42 14 numarasını arayarak da randevu oluşturabilirsiniz. Uygun gün, saat ve tercih ettiğiniz hizmeti birlikte belirleriz.",
  },
  {
    q: "Konak Mahallesi'nde masaj salonu var mı?",
    a: "Evet, Lavenza Masaj Salonu doğrudan Konak Mahallesi'nde, Kurşunlu Sokak üzerinde hizmet vermektedir. Klasik, medikal ve soft masaj ile kese & köpük uygulamalarını aynı adreste bulabilirsiniz. Mahalle içinden yürüyerek, çevre semtlerden ise araç veya toplu taşımayla kolayca ulaşılabilir.",
  },
  {
    q: "Bursa'da masaj randevusu nasıl alınır?",
    a: "Lavenza'da randevu için önceden WhatsApp'tan yazmanızı veya aramanızı öneririz; böylece sizin için uygun bir zaman ayırabiliriz. Mesajınızda istediğiniz hizmeti ve tercih ettiğiniz gün ve saat aralığını belirtmeniz süreci hızlandırır. Fiyat ve süre bilgisi de aynı görüşmede paylaşılır.",
  },
  {
    q: "Nilüfer'de profesyonel masaj hizmeti nerede alınır?",
    a: "Nilüfer'de profesyonel masaj için Konak Mahallesi'ndeki Lavenza Masaj Salonu'na gelebilirsiniz. Her uygulama öncesinde ihtiyacınız dinlenir ve seans size göre planlanır. Hijyen, mahremiyet ve konfor her seansın standart parçasıdır.",
  },
  {
    q: "Lavenza Masaj Salonu hangi hizmetleri sunuyor?",
    a: "Lavenza'da klasik masaj, medikal masaj, soft masaj ve kese & köpük hizmetleri sunulmaktadır. Hangi uygulamanın size uygun olduğundan emin değilseniz WhatsApp üzerinden kısaca durumunuzu anlatabilirsiniz; size yönlendirme yaparız. Fiyat ve süre bilgisi için WhatsApp'tan yazın.",
  },
  {
    q: "WhatsApp üzerinden masaj randevusu alınabilir mi?",
    a: "Evet, randevularımızın büyük bölümü WhatsApp üzerinden alınmaktadır. Sitedeki WhatsApp butonuna dokunduğunuzda \"Merhaba, Lavenza Masaj Salonu için randevu almak istiyorum.\" mesajı hazır olarak açılır; göndermeniz yeterlidir. Mesajınıza çalışma saatlerimiz içinde en kısa sürede dönüş yaparız.",
  },
  {
    q: "Masaj salonuna nasıl yol tarifi alabilirim?",
    a: "Konum bölümündeki \"Yol tarifi al\" bağlantısı, Google Haritalar'da adresimize navigasyonu doğrudan başlatır. Adresimiz Konak Mahallesi, Kurşunlu Sokak, Kat:1 Daire:2, Nilüfer/Bursa'dır. Yolda zorlanırsanız WhatsApp'tan yazabilir veya bizi arayabilirsiniz; size yardımcı oluruz.",
  },
];

export const contactFaq = [
  {
    q: "Çalışma saatleriniz nedir?",
    a: "Lavenza Masaj Salonu her gün 10:00 – 04:00 saatleri arasında hizmet vermektedir. Gece geç saatlerde de randevu oluşturabilirsiniz. Uygunluk için WhatsApp'tan yazmanız yeterlidir.",
  },
  {
    q: "Randevusuz gelebilir miyim?",
    a: "Yoğunluğa bağlı olarak bekleme yaşanabileceği için önceden WhatsApp'tan yazmanızı veya aramanızı öneririz. Böylece sizin için uygun bir zamanı ayırır ve beklemeden hizmet almanızı sağlarız.",
  },
  {
    q: "Salonunuza nasıl ulaşabilirim?",
    a: "Adresimiz Konak Mahallesi, Kurşunlu Sokak, Kat:1 Daire:2, Nilüfer/Bursa. Bu sayfadaki \"Yol tarifi al\" bağlantısıyla Google Haritalar üzerinden navigasyonu başlatabilirsiniz. Ulaşımda zorlanırsanız bizi arayabilirsiniz.",
  },
];
